'use client';

import { useTranslations } from 'next-intl';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { HeroBanner, type HeroBannerPageTitle } from '@/components/frontend/common/hero-banner';
import { FeaturesGrid } from '@/components/frontend/features/features-grid';
import { FeaturesHighlightsSection } from '@/components/frontend/features/features-highlights';

type FeatureItem = {
  id: string;
  title: string;
  description: string;
  icon?: string | null;
  category: string;
  hasDetailPage?: boolean;
  showOnHomePage?: boolean;
  slug?: string | null;
  locale?: string | null;
};

export function FeaturesPageContent({ initialFeatures, initialPageTitle }: { initialFeatures?: FeatureItem[]; initialPageTitle?: HeroBannerPageTitle | null } = {}) {
    const t = useTranslations('features');

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
            <HeroBanner
                page="features"
                title={t('pageTitle')}
                description={t('pageDescription')}
                pill={t('pillLabel')}
                initialPageTitle={initialPageTitle}
            />

            <FeaturesHighlightsSection />

            {/* Dynamic features grid - uses SSG data when initialFeatures provided */}
            <SectionWrapper variant="default" padding="lg" className="relative overflow-hidden">
                <div className="pointer-events-none absolute inset-0 opacity-40">
                    <div className="absolute left-10 top-10 h-80 w-80 rounded-full bg-primary-500/10 blur-3xl" />
                    <div className="absolute right-10 bottom-10 h-80 w-80 rounded-full bg-blue-500/10 blur-3xl" />
                </div>

                <div className="relative z-10 max-w-7xl mx-auto">
                    <FeaturesGrid showCategories={true} initialFeatures={initialFeatures} />
                </div>
            </SectionWrapper>
        </div>
    );
}

